/* eslint-disable import/prefer-default-export */
import { capitalize } from 'lodash'

export function parseResourceTypeName(value: string) {
  return value
    .split(' ')
    .map(word => {
      if (word.charAt(0) === word.charAt(0).toUpperCase()) {
        return word
      }
      return capitalize(word)
    })
    .join(' ')
}
